import styled from 'styled-components';

export const Content = styled.div<{ compact?: boolean }>`
  overflow-y: scroll;
  overflow-x: hidden;
  height: ${(props) => (props.compact ? '220px' : '84vh')};
  padding: ${(props) => (props.compact ? '12px 16px' : '40px 30px')};
  font-size: ${(props) =>
    props.compact ? props.theme.font.body.size.small : 'inherit'};

  color: ${(props) => props.theme.color.text.primary};
  text-align: justify;
  p {
    b {
      font-weight: ${(props) => props.theme.font.body.weight.bold};
    }
  }

  h3 {
    font-weight: ${(props) => props.theme.font.title.weight.bold};
  }

  ul {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.regular};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    font-size: ${(props) => props.theme.font.body.size.small};

    th,
    td {
      border: 1px solid ${(props) => props.theme.color.ui.shade1};
      padding: 8px;
      text-align: left;
      vertical-align: top;
    }

    th {
      background-color: ${(props) => props.theme.color.ui.shade1};
      font-weight: ${(props) => props.theme.font.body.weight.bold};
    }

    ul {
      margin: 0;
      padding-left: 18px;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 20px 30px;

    table {
      font-size: 11px;
    }
  }
`;
